<template>
    <div class="search-filter">
        <button class="btn-add-filter btn-icon-only icon-plus" @click="addNewSearch"></button>
        <div class="filter">
            <v-slide-group show-arrows v-model="fake" ref="slideGroup">
                <v-slide-item v-for="(searchItem, index) in searches" :key="index" :value="index">
                    <filter-item :value="searches[index]" @input="setNewValue(index, $event)"></filter-item>
                </v-slide-item>
            </v-slide-group>
        </div>
        <div class="filter-actions" v-show="searches.length > 0">
            <button class="btn-icon-only icon-search" :class="{'active' : activeMode === 'search'}" @click="activeMode = 'search'"></button>
            <button class="btn-icon-only icon-filter" :class="{'active' : activeMode === 'filter'}" @click="activeMode = 'filter'"></button>
        </div>
    </div>
</template>

<script>
  import FilterItem from '@/components/filter/FilterItem'
  import _ from 'lodash'

  export default {
    components: { FilterItem },
    data () {
      return {
        searches: [],
        slideGroup: null,
        fake: 0
      }
    },
    mounted () {
      this.searches = _.cloneDeep(this.getActiveSearches)
    },
    methods: {
      addNewSearch () {
        let item = this.$store.getters['search/getSearchOptions'].find((item) => item.handle === 'all')
        this.searches.push({
          editMode: true,
          item,
          path: 'all'
        })
        this.fake = this.searches.length - 1
        this.$refs.slideGroup.onResize()
      },
      setNewValue (index, data) {
        if (typeof data.item === 'undefined') {
          this.searches.splice(index, 1)
          this.fake = index - 1
        } else {
          this.$set(this.searches, index, data)
          this.fake = index
        }

        if (!data.editMode) {
          this.$store.dispatch('search/setSearches', _.cloneDeep(this.searches))
        }

        if (this.searches.length === 0) {
          this.activeMode = 'filter'
        }
        this.$refs.slideGroup.onResize()
      }
    },
    computed: {
      getActiveSearches () {
        return this.$store.getters['search/getSearches'] ? this.$store.getters['search/getSearches'] : []
      },
      activeMode: {
        get () {
          return this.$store.getters['search/getSearchMode']
        },
        set (newVal) {
          this.$store.dispatch('search/setSearchMode', newVal)
        }
      }
    }
  }
</script>

<style scoped>

</style>
